export const STORAGE_KEY = 'msc-translated-messages';
export const MAXIMUM_TRANSLATED_MESSAGES_PER_THREAD = 20;
export const TRANSLATION_CACHE_EXPIRATION_IN_DAYS = 14;
